import { __assign } from "tslib";
import * as React from 'react';
function IconPlaySizeM(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M21 11.1732C21.4445 11.4298 21.4445 12.0713 21 12.3279L7 20.4108C6.55555 20.6674 6 20.3467 6 19.8335V3.66766C6 3.15446 6.55556 2.83371 7 3.09031L21 11.1732Z", fill: "white" })));
}
export default IconPlaySizeM;
